import styled from "styled-components";
import { Menu as AntdMenu, Flex } from "antd";

export const Container = styled(Flex)`
  flex-direction: column;
  height: 100%;
  overflow: auto;
`;

export const Content = styled.nav`
  flex: 1 1 auto;
  padding-bottom: 16px;
`;

export const Menu = styled(AntdMenu)<{ $primaryColor: string }>`
  &.ant-menu-light.ant-menu-inline .ant-menu-sub.ant-menu-inline {
    background: transparent !important;
  }

  .ant-menu-submenu-title {
    margin: 0;
  }

  &.ant-menu-light .ant-menu-item {
    position: relative;
    color: #000;
  }

  .ant-menu-submenu-open {
    color: ${({ $primaryColor }) => $primaryColor} !important;
  }

  .ant-menu-submenu-arrow {
    color: #000 !important;
  }

  .ant-menu-submenu-open > .ant-menu-submenu-title .ant-menu-submenu-arrow {
    color: #000 !important;
  }

  &.ant-menu-light .ant-menu-item-selected {
    background-color: ${({ $primaryColor }) => `${$primaryColor}15`} !important;
    color: ${({ $primaryColor }) => $primaryColor} !important;
    border-radius: 0;
  }

  &.ant-menu-light .ant-menu-item-selected:hover {
    background-color: ${({ $primaryColor }) => `${$primaryColor}15`} !important;
    color: ${({ $primaryColor }) => $primaryColor} !important;
  }

  &.ant-menu-light .ant-menu-item-selected::after {
    background-color: ${({ $primaryColor }) => $primaryColor} !important;
    width: 3px;
  }

  &.ant-menu-light .ant-menu-item-selected .anticon {
    color: ${({ $primaryColor }) => $primaryColor} !important;
  }

  &.ant-menu-light .ant-menu-item:not(.ant-menu-item-selected):hover {
    background-color: transparent !important;
  }

  .ant-menu-item-divider {
    margin: 0;
  }
`;

export const CollapsedCorbanIcon = styled.div`
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  svg {
    font-size: 18px;
    color: rgba(0, 0, 0, 0.65);
  }

  &:hover {
    background: rgba(0, 0, 0, 0.04);
  }
`;
